export default `
  mutation($articlesIds: [String]!,$auditor: String! ) {
    sendNotice(noticedArticles: { 
      articlesIds: $articlesIds
      auditor: $auditor
    }) { 
      articlesIds
    }
  }
 `;